import { OperationType } from '../types/enums';

const keyOperations = [
  OperationType.REQUEST,
  OperationType.APPROVE,
  OperationType.UPDATE_APPROVED,
  OperationType.SUBMIT_QUERIED,
  OperationType.SUSPEND,
  OperationType.REQUEST_EXTENSION,
  OperationType.EXTEND,
  OperationType.MANUAL_PAYMENT,
  OperationType.REQUEST_AMENDMENT,
  OperationType.APPROVE_AMENDMENT,
];

export const getIsKeyOperation = (operation: string) =>
  keyOperations.includes(operation as OperationType) || !(operation in OperationType);
